<div class="card">
    <app-grain-metric-value-barchart></app-grain-metric-value-barchart>
</div>

